import { differenceInHours, parseISO } from 'date-fns';

import {
  SESSION_CLOSED_BANNERS,
  CLOSED_LYFE_CYCLE,
  BANNER_APPLIED,
  BANNER_EXPIRES_SOON,
} from './constants';

export function validateClosedBanners() {
  const closedBanners = getClosedBanners();

  let listRemainsClosed = [];

  if (closedBanners.length > 0) {
    listRemainsClosed = closedBanners.filter(banner => {
      const difHours = differenceInHours(
        parseISO(new Date().toJSON()),
        parseISO(banner.timeStamp),
      );
      return difHours < CLOSED_LYFE_CYCLE;
    });

    sessionStorage.setItem(
      SESSION_CLOSED_BANNERS,
      JSON.stringify(listRemainsClosed),
    );
  }
  return listRemainsClosed;
}

export const getClosedBanners = () =>
  sessionStorage.getItem(SESSION_CLOSED_BANNERS)
    ? JSON.parse(sessionStorage.getItem(SESSION_CLOSED_BANNERS))
    : [];

export function appliedClosed(targetedOffer) {
  const closedBanners = getClosedBanners();

  const expiresSoonBanners = closedBanners.filter(
    banner => banner.type === BANNER_EXPIRES_SOON,
  );

  sessionStorage.setItem(
    SESSION_CLOSED_BANNERS,
    JSON.stringify([
      ...expiresSoonBanners,
      {
        promoCode: targetedOffer.code,
        timeStamp: new Date(),
        type: BANNER_APPLIED,
      },
    ]),
  );
}

export function expiresSoonClosed(targetedOffer) {
  const closedBanners = getClosedBanners();

  const noExpiresSoonBanners = closedBanners.filter(
    banner => banner.type !== BANNER_EXPIRES_SOON,
  );

  sessionStorage.setItem(
    SESSION_CLOSED_BANNERS,
    JSON.stringify([
      ...noExpiresSoonBanners,
      {
        promoCode: targetedOffer.code,
        timeStamp: new Date(),
        type: BANNER_EXPIRES_SOON,
      },
    ]),
  );
}
